import { render, staticRenderFns } from "./search-suggestions.vue?vue&type=template&id=0757ca0f&scoped=true&"
import script from "./search-suggestions.vue?vue&type=script&lang=js&"
export * from "./search-suggestions.vue?vue&type=script&lang=js&"
import style0 from "./search-suggestions.vue?vue&type=style&index=0&id=0757ca0f&prod&lang=scss&"
import style1 from "./search-suggestions.vue?vue&type=style&index=1&id=0757ca0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0757ca0f",
  null
  
)

export default component.exports